export const Groups = {
  SUPERUSER: "brinkcommerce-superuser",
  READONLY: "brinkcommerce-readonly",
  CAMPAIGN_USER: "brinkcommerce-campaignuser",
  USER_ADMIN: "brinkcommerce-useradmin",
  CX_USER: "cx-user",
  CX_ADMIN: "cx-admin",
  ECOM_USER: "ecom-user",
  ECOM_ADMIN: "ecom-admin",
  SYSTEM_USER: "system-user",
  SYSTEM_ADMIN: "system-admin"
} as const

export const PermissionGroups = {
  salesDashboards: {
    read: [Groups.SUPERUSER, Groups.READONLY, Groups.ECOM_USER, Groups.ECOM_ADMIN]
  },
  insightsDashboards: {
    read: [Groups.SUPERUSER, Groups.READONLY, Groups.ECOM_USER, Groups.ECOM_ADMIN]
  },
  operationsDashboards: {
    read: [Groups.CX_USER, Groups.CX_ADMIN]
  },
  orders: {
    read: [Groups.SUPERUSER, Groups.READONLY, Groups.CX_USER, Groups.CX_ADMIN, Groups.SYSTEM_ADMIN],
    write: [Groups.SUPERUSER, Groups.CX_ADMIN, Groups.CX_USER],
    execute: [Groups.SUPERUSER, Groups.CX_ADMIN],
    delete: [Groups.SUPERUSER, Groups.SYSTEM_ADMIN]
  },
  customers: {
    read: [Groups.SUPERUSER, Groups.READONLY, Groups.CX_USER, Groups.CX_ADMIN]
  },
  insights: {
    read: [
      Groups.READONLY,
      Groups.SUPERUSER,
      Groups.ECOM_USER,
      Groups.ECOM_ADMIN,
      Groups.CX_USER,
      Groups.CX_ADMIN
    ]
  },
  products: {
    read: [
      Groups.SUPERUSER,
      Groups.READONLY,
      Groups.CX_USER,
      Groups.CX_ADMIN,
      Groups.ECOM_USER,
      Groups.ECOM_ADMIN
    ]
  },
  discounts: {
    read: [Groups.SUPERUSER, Groups.READONLY, Groups.ECOM_USER, Groups.ECOM_ADMIN],
    write: [Groups.SUPERUSER, Groups.ECOM_ADMIN]
  },
  campaigns: {
    read: [
      Groups.SUPERUSER,
      Groups.CAMPAIGN_USER,
      Groups.READONLY,
      Groups.ECOM_USER,
      Groups.ECOM_ADMIN
    ],
    write: [Groups.SUPERUSER, Groups.CAMPAIGN_USER, Groups.ECOM_ADMIN]
  },
  states: {
    write: [Groups.CX_ADMIN, Groups.SUPERUSER]
  },
  stores: {
    read: [
      Groups.SUPERUSER,
      Groups.READONLY,
      Groups.CX_USER,
      Groups.CX_ADMIN,
      Groups.ECOM_USER,
      Groups.ECOM_ADMIN,
      Groups.SYSTEM_USER,
      Groups.SYSTEM_ADMIN
    ],
    write: [Groups.SUPERUSER, Groups.SYSTEM_ADMIN, Groups.ECOM_ADMIN]
  },
  inventories: {
    read: [
      Groups.SUPERUSER,
      Groups.READONLY,
      Groups.ECOM_USER,
      Groups.ECOM_ADMIN,
      Groups.SYSTEM_USER,
      Groups.SYSTEM_ADMIN
    ],
    write: [Groups.SUPERUSER, Groups.ECOM_ADMIN, Groups.SYSTEM_ADMIN]
  },
  users: {
    read: [Groups.USER_ADMIN, Groups.SYSTEM_USER, Groups.SYSTEM_ADMIN],
    write: [Groups.USER_ADMIN, Groups.SYSTEM_ADMIN]
  },
  tax: {
    read: [
      Groups.SUPERUSER,
      Groups.READONLY,
      Groups.ECOM_USER,
      Groups.ECOM_ADMIN,
      Groups.SYSTEM_ADMIN,
      Groups.SYSTEM_USER
    ],
    write: [Groups.SUPERUSER, Groups.SYSTEM_ADMIN, Groups.ECOM_ADMIN]
  },
  providers: {
    read: [Groups.SUPERUSER, Groups.READONLY, Groups.SYSTEM_USER, Groups.SYSTEM_ADMIN],
    write: [Groups.SUPERUSER, Groups.SYSTEM_ADMIN]
  },
  externalEvents: {
    read: [Groups.SUPERUSER, Groups.SYSTEM_USER, Groups.SYSTEM_ADMIN],
    write: [Groups.SUPERUSER, Groups.SYSTEM_ADMIN]
  },
  apiClients: {
    read: [Groups.SUPERUSER, Groups.SYSTEM_USER, Groups.SYSTEM_ADMIN],
    write: [Groups.SUPERUSER, Groups.SYSTEM_ADMIN]
  },
  system: {
    read: [Groups.SUPERUSER, Groups.SYSTEM_USER, Groups.SYSTEM_ADMIN],
    write: [Groups.SUPERUSER, Groups.SYSTEM_ADMIN]
  },
  workflows: {
    read: [
      Groups.SUPERUSER,
      Groups.READONLY,
      Groups.CX_USER,
      Groups.CX_ADMIN,
      Groups.ECOM_USER,
      Groups.ECOM_ADMIN,
      Groups.SYSTEM_ADMIN
    ],
    write: [Groups.SUPERUSER, Groups.SYSTEM_ADMIN, Groups.CX_ADMIN]
  },
  actionNeeded: {
    operations: [Groups.CX_ADMIN],
    workflows: [Groups.CX_ADMIN, Groups.SYSTEM_ADMIN]
  },
  checkouts: {
    read: [
      Groups.SUPERUSER,
      Groups.READONLY,
      Groups.CX_USER,
      Groups.CX_ADMIN,
      Groups.ECOM_USER,
      Groups.ECOM_ADMIN,
      Groups.SYSTEM_ADMIN
    ],
    write: [Groups.SUPERUSER, Groups.SYSTEM_ADMIN, Groups.CX_ADMIN]
  }
}
